export enum DEBUG_MODE {
    KEY = '__debug_mode__',
    ERROR = 1,
    WARNING = 2,
    NOTICE = 3,
    N_COLOR = "#c3efed",
    W_COLOR = "#c0b721",
    E_COLOR = "#c53e3e",
}

export const DEF_STORE_ID = "__cactus_store__";

export enum REACTIVE {
    ENDPOINT = "/jsonapi/paragraph"
}

export const SPINNER_DURATION = 1000;